import { Component, OnInit, Output, Input, EventEmitter, HostListener, ElementRef, SimpleChanges, ChangeDetectionStrategy, ViewChild, AfterViewInit, OnDestroy, OnChanges, ChangeDetectorRef, forwardRef } from '@angular/core';
import { GlobalService } from '../services/global.service';
import { SearchPipe } from '../pipes/search.pipe';
import { fromEvent, Observable, Subscription } from 'rxjs';
import * as _ from 'lodash';
import {
	NG_VALUE_ACCESSOR,
	NG_VALIDATORS,
	Validator,
	AbstractControl,
	UntypedFormControl,
	ControlValueAccessor
}
	from '@angular/forms';
import { get } from 'https';

@Component({
    selector: 'app-page-input',
    templateUrl: './page-input.component.html',
    styleUrls: ['./page-input.component.css'],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => PageInputComponent),
            multi: true
        },
        {
            provide: NG_VALIDATORS,
            useExisting: forwardRef(() => PageInputComponent),
            multi: true,
        }
    ]
    // changeDetection:ChangeDetectionStrategy.OnPush,
    ,
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class PageInputComponent implements OnInit, OnChanges, ControlValueAccessor {

	@ViewChild('theInput', { static: false }) theInput: ElementRef;
	@Input() appModel: any;
	@Input() useTrackBy: boolean = false;
	@Input() placeholder: string;
	@Input() required: boolean;
	@Input() color: boolean;
	@Input() disabled: boolean;
	@Input() createValue: string;

	@Output() appModelChange = new EventEmitter<string>();
	@Output() createValueChange = new EventEmitter<string>();
	@Output() appChange = new EventEmitter<string>();
	@Output() onClose = new EventEmitter<string>();


	pages: string;
	fraction: string;


	onChange: any = () => { };
	onTouched: any = () => { };


	showOptions: boolean = false;
	wasInside: boolean = false;
	itemWasSelected: boolean = false;
	firstOpen: boolean = false;
	wasClickNav: boolean = false;

	sliceStart: number = 0
	sliceLength: number = 25
	sliceEnd: number = this.sliceLength
	selected_color: any = [];
	subs: Subscription[] = [];

	value: any;

	clickEmpty() {
		this.appModel = undefined
		this.appModelChange.emit(this.appModel);
		this.setValueControl(this.appModel)
	}

	constructor(
		private _elementRef: ElementRef,
		public _gS: GlobalService,
		private _SearchPipe: SearchPipe,
		private _cD: ChangeDetectorRef) { }

	onChangeHandler() {
		if (!this.pages && this.fraction) {
			this.pages = '0'
		}
		var a: number = this.pages ? parseInt(this.pages) : 0;
		var b: number = this.fraction ? parseInt(this.fraction) : 0;
		this.appModel = a + (b / 8)
		if (b > 7) {
			this.appModel = undefined
		}
		this.appModelChange.emit(this.appModel);
		this.setValueControl(this.appModel)
	}


	ngOnChanges(changes: SimpleChanges) {
		if (changes.appModel) {
			if (changes.appModel.currentValue) {
				var a = Math.floor(changes.appModel.currentValue)
				var b = (parseFloat(changes.appModel.currentValue) - a) * 8
				this.pages = a.toString();
				this.fraction = b.toString();
			}
		}
	}
	setChange() { }

	ngOnInit() {
		this.setChange();
	}

	setValueControl(value) {
		this.value = value
		this.onChange(value)
	}

	public writeValue(value: any): void {
		this.value = value;
	}

	public registerOnChange(fn: any): void {
		this.onChange = fn;
	}
	public registerOnTouched(fn: any): void {
		this.onTouched = fn;
	}
	setDisabledState?(isDisabled: boolean): void {
		this.disabled = isDisabled;
	}


	public validate(c: UntypedFormControl) {
		return (this.value) ? null : {
			inputError: {
				valid: false,
			},
		};
	}


}
